var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYogaMat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6649 20L23.5198 13.9973C23.7713 13.8098 23.9922 13.5929 24.1825 13.3467C24.8291 12.5067 24.8171 11.3387 24.4065 10.3627C23.9396 9.26302 23.1586 8.32568 22.1612 7.66817C21.1637 7.01066 19.9944 6.66227 18.7998 6.66667C17.5518 6.66667 16.3918 7.03867 15.4278 7.676L7.33154 13.3333C17.3315 13.3467 14.6649 20 14.6649 20Z",
    fill: "#F4D5C0",
    stroke: "#E85D04",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.65983 18.008C8.65983 18.936 9.15183 20.7813 11.3798 21.288C12.7225 21.592 16.6305 20.3067 14.7185 16.584C12.8065 12.8613 8.2025 12.8427 6.32916 14.0907C5.18383 14.784 2.96116 16.9547 3.3825 19.8387C3.53316 21.5853 4.90916 25.132 9.21583 25.3347H22.4052C23.6345 25.2373 23.8878 25.0587 24.8238 24.3413C26.0838 23.2107 28.1865 21.1307 29.4092 19.7613C29.6732 19.4667 29.9572 19.1613 29.9945 18.7667C30.1878 16.6653 26.9985 17.576 24.6878 17.3253",
    stroke: "#E85D04",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYogaMat);
export default __webpack_public_path__ + "static/media/YogaMat.ea4b9b04b3983711d2aac030874d83ec.svg";
export { ForwardRef as ReactComponent };